export const EXAMINERS_REQUEST_START = 'EXAMINERS_REQUEST_START';
export const FETCH_EXAMINERS_SUCCESS = 'FETCH_EXAMINERS_SUCCESS';
export const FETCH_EXAMINERS_ERROR = 'FETCH_EXAMINERS_ERROR';
export const LOAD_MORE_EXAMINERS_SUCCESS = 'LOAD_MORE_EXAMINERS_SUCCESS';
